import React from 'react';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { LinkText } from "../../ecosystem";

const VideoVisitTestLink = (props) => {

    return (<div className="video-visit-test-link text-right">
        <LinkText
            to="/videovisit/test"
            onClick={() => logUI("MBHWeb.Dashboard.AppointmentTile.TestVideo.Click", new Date(), Tools.getURLPath())}
            typographyType="body-02"
        >
            TEST VIDEO VISIT
        </LinkText>
    </div>);
}

export default VideoVisitTestLink;
